import { createSlice } from "@reduxjs/toolkit";

const initialLocalLogState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  localLogForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const localLogSlice = createSlice({
  name: "localLog",
  initialState: initialLocalLogState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    localLogFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    localLogAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    localLogCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.localLog.push(action.payload.localLog);
    },
    localLogDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.localLog.filter(
        (el) => el.follow_up_id !== action.payload.id,
      );
    },
    getLocalLog: (state, action) => {
      state.actionsLoading = false;
      state.localLogForEdit = action.payload.localLogForEdit;
      state.error = null;
    },
    // updateProduct
    localLogUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.localLog = state.entities.localLog.map((entity) => {
        if (entity.follow_up_id === action.payload.localLog.follow_up_id) {
          return action.payload.localLog;
        }
        return entity;
      });
    },
  },
});
